require('./brokerIntervenerList.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const BrokerIntervenerItem = require('components/broker/brokerIntervener/brokerIntervenerItem/brokerIntervenerItem');
// @ actions
const BrokerStocksContractActions = require('actions/brokerStocksContractForm');
const intervenersActions = require('actions/getAccountInterveners');
// @ constants
const { COUNTRIES_CODES: { ES } } = require('constants/countries');
const { BROKER_CONTRACT_OWNER } = require('constants/index');


class BrokerIntervenerList extends React.Component {
    constructor(props) {
        super(props);
        this.hasOnlyOneOwner = this.hasOnlyOneOwner.bind(this);
        this.buildIntervenerList = this.buildIntervenerList.bind(this);
        this.buildLinkActions = this.buildLinkActions.bind(this);
        this.handleIntervenerNameChange = this.handleIntervenerNameChange.bind(this);
        this.handleIntervenerTypeChange = this.handleIntervenerTypeChange.bind(this);
        this.handleIntervenerRemove = this.handleIntervenerRemove.bind(this);
        this.handleIntervenerAddClick = this.handleIntervenerAddClick.bind(this);
        this.handleRestoreDefaultClick = this.handleRestoreDefaultClick.bind(this);
    }

    buildIntervenerList() {
        const CONTRACT_OWNER = formatText(BROKER_CONTRACT_OWNER, [], ES.toLowerCase()).toUpperCase();
        const { currentInterveners, availableInterveners, originalInterveners } = this.props;
        const hasOnlyOneOwner = this.hasOnlyOneOwner(currentInterveners);

        return currentInterveners.map((intervener, index) => {
            const interveners = availableInterveners.push(intervener);
            const isOnlyOwner = hasOnlyOneOwner && intervener.get('type') === CONTRACT_OWNER;

            return (
                <BrokerIntervenerItem
                    key={index}
                    index={index}
                    originalInterveners={interveners}
                    intervenerName={intervener.get('name')}
                    intervenerType={intervener.get('type')}
                    onIntervenerNameChange={this.handleIntervenerNameChange}
                    onIntervenerTypeChange={this.handleIntervenerTypeChange}
                    onIntervenerRemove={this.handleIntervenerRemove}
                    isOnlyIntervener={originalInterveners.size === 1}
                    isOnlyOwner={isOnlyOwner}
                    nameLabelFormat={false}
                    showRemoveIcon={!isOnlyOwner}
                />
            );
        });
    }

    buildLinkActions() {
        const { currentInterveners, originalInterveners } = this.props;
        const addIntervenerLabel = formatText('broker-stockIntervenerAddIntervenerLabel');
        const restoreValuesLabel = formatText('broker-stockIntervenerRestoreValuesLabel');

        if (currentInterveners && originalInterveners && currentInterveners.size !== originalInterveners.size) {
            return (
                <div>
                    <OKButton
                        id="btnBrokerIntervenerListAddElement"
                        modifier="link-complementary"
                        onClick={this.handleIntervenerAddClick}
                    >
                        {addIntervenerLabel}
                    </OKButton>
                    <span className="intervener-list__action-links"> | </span>
                    <OKButton
                        id="btnBrokerIntervenerListRemoveElement"
                        modifier="link-complementary"
                        onClick={this.handleRestoreDefaultClick}
                    >
                        {restoreValuesLabel}
                    </OKButton>
                </div>
            );
        }
    }

    handleIntervenerAddClick(e) {
        e.preventDefault();
        this.props.addIntervener();
    }

    handleIntervenerNameChange(index, name) {
        const { originalInterveners } = this.props;
        this.props.setIntervenerName(index, name, originalInterveners);
    }

    handleIntervenerRemove(index) {
        const { removeIntervener, originalInterveners } = this.props;
        removeIntervener(index, originalInterveners);
    }

    handleIntervenerTypeChange(index, type) {
        this.props.setIntervenerType(index, type)
    }

    handleRestoreDefaultClick(e) {
        e.preventDefault();
        const { originalInterveners } = this.props;
        this.props.restoreDefaultInterveners(originalInterveners);
    }

    hasOnlyOneOwner(currentInterveners) {
        const CONTRACT_OWNER = formatText(BROKER_CONTRACT_OWNER, [], ES.toLowerCase()).toUpperCase();
        const onlyOwnersList = currentInterveners.filter((intervener) => {
            return intervener.get('type') === CONTRACT_OWNER;
        });

        return onlyOwnersList.size <= 1;
    }

    render() {
        const intervenerList = this.buildIntervenerList();
        const linkActions = this.buildLinkActions();

        return (
            <section className="intervener-list">
                <header className="intervener-list__header">
                    <h3 className="intervener-list__title">
                        <FormattedText value="broker-stocksContractIntervenerTitle" />
                        <OKTooltip
                            offset={[15, 10]}
                            content="brokerIntevenerItem-tooltip"
                            placement="right"
                        />
                    </h3>

                </header>

                <section>
                    {intervenerList}
                    {linkActions}
                </section>
            </section>
        );
    }
}

BrokerIntervenerList.propTypes = {
    currentInterveners: PropTypes.object,
    availableInterveners: PropTypes.object,
    originalInterveners: PropTypes.object,
    accountId: PropTypes.string,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    requestAccountInterveners: PropTypes.func
};

module.exports.constructor = BrokerIntervenerList;
module.exports.BrokerIntervenerList = connect(
  () => ({
  }), {
      setIntervenerName: BrokerStocksContractActions.setIntervenerName,
      setIntervenerType: BrokerStocksContractActions.setIntervenerType,
      addIntervener: BrokerStocksContractActions.addIntervener,
      removeIntervener: BrokerStocksContractActions.removeIntervener,
      restoreDefaultInterveners: BrokerStocksContractActions.restoreDefaultInterveners,
      requestInterveners: intervenersActions.requestAccountInterveners
  })(BrokerIntervenerList);
